import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A COMPLETE TRAINING SYSTEM.', 'CLEAR LABELED DIAGRAMS.', 'STEP-BY-STEP TECHNIQUES.', '❌/✅ COMPARISONS.', 'READY PROJECT BANKS.', 'CLEAR ASSESSMENT CRITERIA.', 'READY-TO-TEACH CLASSES.', 'BETTER CLASS PREPARATION.'];
const alreadyHave = ['You already have the tools, machine, fabric and stitch visuals.', 'You already have the measuring, block drafting and pattern symbol guides.', 'You already have the dart manipulation, draping and fitting sequences.', 'You already have the cutting, assembly, zipper and closure methods.', 'You already have the tailoring, finishing and alteration workflows.', 'You already have the lesson plans, course programs and practical assessments.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-[#E6D5BF]" data-id="element-68" data-mp="216e2n56rzhag">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-69" data-mp="1wct49c19slaq">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#520128] mb-6 uppercase" data-id="element-70" data-mp="1v61iz952yaf4">
          You Don&apos;t Need More Scattered <span className="text-[#8E2C5C]" data-id="element-71" data-mp="203la39mvmhoh">Sewing Teaching Resources.</span>
        </h2>
        <p className="text-xl text-slate-700/80 mb-5" data-id="element-72" data-mp="1l6kg0zh7qamu">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-73" data-mp="1q6gn57l7ii6m">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-[#520128] tracking-wide" data-id="element-74" data-mp="1c7h0u6l62fdm">
              {need}
            </li>)}
        </ul>
        <div className="bg-[#F8F3EC] border border-[#E6D5BF] rounded-2xl p-8 text-lg text-slate-700 space-y-2 text-left sm:text-center" data-id="element-75" data-mp="1h7v65gvdvb7y">
          <p className="mb-4" data-id="element-76" data-mp="3bkba2b0pid9n">
            With SEWING &amp; PATTERN MAKING INSTRUCTOR ATLAS, you don&apos;t start every class searching through
            books, handouts, videos and old notes.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-[#520128] font-semibold flex items-center sm:justify-center gap-2" data-id="element-77" data-mp="355w0x32mbgwt">
              <Check size={18} className="text-[#8E2C5C] shrink-0" aria-hidden="true" data-id="element-78" data-mp="2v6erqbo5qkw3" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-79" data-mp="3sskjlqzgbdeh">
            And with the five exclusive bonuses, you also have sewing technique and stitch reference flashcards,
            sewing demonstration lesson scripts, pattern-making practice drills and quarter-scale exercises, fitting
            and alterations troubleshooting cards, and sewing competency checklists, rubrics and certificates to help
            you plan, teach, correct and assess your students.
          </p>
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#520128]" data-id="element-80" data-mp="anhazwaa0j9b">
            YOU ALREADY HAVE <span className="text-[#8E2C5C]" data-id="element-81" data-mp="hzys48in5s0d">THE TRAINING FRAMEWORK.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}